// extracted by mini-css-extract-plugin
module.exports = {"header":"CategoryHeader_header__LXILv"};